// Central place for billing config the client needs to know about.
// Dollar amounts here are purely for UI display — the actual charge comes
// from Stripe based on price_id, not what we show. Keep them in sync when
// you update Stripe prices.

// Trial lengths are deliberately different.
// Customers: 14 days is plenty to validate "can I make one cool tattoo?"
// Artists: 30 days so they have time to build a profile, upload flash, and
//   see leads come in before deciding to subscribe.
export const TRIAL_DAYS = 14;
export const ARTIST_TRIAL_DAYS = 30;

export const PLANS = {
  customer_pro: {
    id: "customer_pro",
    name: "Customer Pro",
    audience: "customer",
    price: "$9.99",
    cadence: "/mo",
    features: [
      "Unlimited saved designs",
      "HD exports",
      "Full flash gallery access",
      "Cancel anytime",
    ],
  },
  customer_pro_yearly: {
    id: "customer_pro_yearly",
    name: "Customer Pro (Yearly)",
    audience: "customer",
    price: "$89.99",
    cadence: "/yr",
    features: ["Save ~25% vs monthly", "Everything in Customer Pro"],
  },
  artist_pro: {
    id: "artist_pro",
    name: "Artist Pro",
    audience: "artist",
    price: "$19",
    cadence: "/mo",
    features: [
      "Public artist profile in the Tattune directory",
      "Upload your flash gallery",
      "Lead form — client inquiries land in your inbox",
      "Everything in Customer Pro",
    ],
  },
  artist_pro_yearly: {
    id: "artist_pro_yearly",
    name: "Artist Pro (Yearly)",
    audience: "artist",
    price: "$190",
    cadence: "/yr",
    features: ["Save ~17% vs monthly", "Everything in Artist Pro"],
  },
  single_design: {
    id: "single_design",
    name: "Single Design",
    audience: "customer",
    price: "$4.99",
    cadence: "one-time",
    features: [
      "Design and save one tattoo project",
      "Great for second-tat top-ups",
      "No subscription",
    ],
  },
};
